import React, { useEffect, useState } from "react";

interface MessageTileProps {
  isVisible: boolean;
  message: string;
  type: "success" | "error" | "info" | "warning";
}

const MessageTile: React.FC<MessageTileProps> = ({
  isVisible,
  message,
  type,
}) => {
  const [visible, setVisible] = useState(isVisible);

  // Hide the toast after some time (e.g., 5 seconds)
  useEffect(() => {
    if (isVisible) {
      setVisible(true);
      const timer = setTimeout(() => {
        setVisible(false);
      }, 10000); // Auto hide after 20 seconds

      return () => clearTimeout(timer);
    }
  }, [isVisible]);

  if (!visible) return null;
  return (
    <div
      className={`message-tile message-tile--${type}`}
      role="status"
      aria-live="polite"
    >
      <span className="message-tile-text">{message}</span>
      <button
        type="button"
        className="message-tile-close"
        aria-label="Close notification"
        onClick={() => setVisible(false)}
      >
        ×
      </button>
    </div>
  );
};

export default MessageTile;
